export const workspace = {
  routes: [
    {
      path: "/workspace/library/policy",
      component: () => import("../workspace-library-policy-view"),
    },
    {
      path: "/workspace/library/policy-group",
      component: () => import("../workspace-library-policy-group-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/policy",
      component: () => import("../management-library-policy-view"),
    },
    {
      path: "/management/policy-group",
      component: () => import("../management-library-policy-group-view"),
    },
  ],
};

export const gdpr = {
  routes: [
    {
      path: "/gdpr/policy",
      component: () => import("../gdpr-policy"),
    },
    {
      path: "/gdpr/policy-detail/:id",
      component: () => import("../organization-policy-detail"),
    },
  ],
};

export const kvkk = {
  routes: [
    {
      path: "/kvkk/policy",
      component: () => import("../kvkk-policy"),
    },
    {
      path: "/kvkk/policy-detail/:id",
      component: () => import("../organization-policy-detail"),
    },
  ],
};

export const ddo = {
  routes: [
    {
      path: "/ddo/policy",
      component: () => import("../ddo-policy"),
    },
    {
      path: "/ddo/policy-detail/:id",
      component: () => import("../organization-policy-detail"),
    },
  ],
};
export const bgys = {
  routes: [
    {
      path: "/bgys/policy",
      component: () => import("../bgys-policy"),
    },
    {
      path: "/bgys/policy-detail/:id",
      component: () => import("../organization-policy-detail"),
    },
  ],
};

export const organization = {
  routes: [
    {
      path: "/organization/policy",
      component: () => import("../organization-policy"),
    },
    {
      path: "/organization/policy-detail/:id",
      component: () => import("../organization-policy-detail"),
    },
  ],
};
